import { Component, OnInit } from '@angular/core';
import { LifetimeDepositThresholdsService } from './lifetime-deposit-thresholds.service';
import { LifetimeRiskDepositThresholdDTO } from './lifetime-deposit-thresholds';

@Component({
  selector: 'app-lifetime-deposit-thresholds',
  templateUrl: './lifetime-deposit-thresholds.component.html',
  styleUrls: ['./lifetime-deposit-thresholds.component.scss'],
  standalone: false,
})
export class LifetimeDepositThresholdsComponent implements OnInit {
  constructor(private service: LifetimeDepositThresholdsService) {}

  thresholdsByRisk?: LifetimeRiskDepositThresholdDTO[];

  ngOnInit(): void {
    this.service.get().subscribe((params) => (this.thresholdsByRisk = params));
  }
}
